import React from "react";
import {
  Form,
  FormError,
  Label,
  LabelInput,
  Select,
  TextArea
} from "../../common/components/form";
import {
  StyledPreviewWrapper,
  StyledPreviewButton,
  StyledPreview,
  StyledCheckBox
} from "../../common/components/form/ui/";
import Figure from "../../common/components/Figure";
import Button from "../../../ui/button/Button";
import { Localize } from "../../../locale/localization";
import ContentTargetings from "./ContentTargetings";
import ContentTags from "./ContentTags";

const ContentForm = props => {
  const {
    enabled,
    onSubmit,
    onBlur,
    onCancel,
    onDelete,
    onInputChange,
    onFileInputChange,
    onContentPreviewToggle,
    onTargetingChange,
    onTagChange,
    errors,
    touchedFields,
    isValid,
    channel,
    channels,
    tags,
    targetings,
    pinned,
    name,
    category,
    content,
    contentPreview,
    imageUrl,
    videoUrl,
    formError,
    contentType,
    showDeleteButton
  } = props;

  const options = channels
    ? channels.map(op => (
        <option key={op._id} value={op._id}>
          {op.name}
        </option>
      ))
    : null;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      {contentType === "rules" &&
        channels &&
        channels.length > 0 && (
          <Label half label="Jälleenmyyjä">
            <Select
              value={channel}
              name="channel"
              error={errors["channel"] && touchedFields.indexOf("channel") > -1}
              errorMessage={errors["channel"]}
              onChange={onInputChange}
            >
              <option value="" disabled>
                {Localize("channel")}
              </option>
              {options}
            </Select>
          </Label>
        )}

      {contentType !== "rules" &&
        contentType !== "news" && (
          <ContentTargetings
            name="targetings"
            targetings={targetings}
            onChange={onTargetingChange}
            error={
              errors["targetings"] && touchedFields.indexOf("targetings") > -1
            }
            errorMessage={errors["targetings"]}
          />
        )}

      <LabelInput
        tight
        type="text"
        label="Nimi"
        name="name"
        value={name}
        error={errors["name"] && touchedFields.indexOf("name") > -1}
        errorMessage={errors["name"]}
        onChange={onInputChange}
      />

      {contentType !== "rules" && (
        <LabelInput
          type="text"
          label="Kategoria"
          name="category"
          value={category}
          error={errors["category"] && touchedFields.indexOf("category") > -1}
          errorMessage={errors["category"]}
          onChange={onInputChange}
        />
      )}

      <StyledPreviewWrapper>
        <StyledPreviewButton
          onClick={onContentPreviewToggle}
          className={content.length === 0 && "disabled"}
        >
          {contentPreview ? "Muokkaa" : "Esikatsele"}
        </StyledPreviewButton>
        {contentPreview && (
          <StyledPreview dangerouslySetInnerHTML={{ __html: content }} />
        )}
        {!contentPreview && (
          <LabelInput
            Component={TextArea}
            rows="10"
            label="Teksti"
            name="content"
            value={content}
            error={errors["content"] && touchedFields.indexOf("content") > -1}
            errorMessage={errors["content"]}
            onChange={onInputChange}
          />
        )}

        {contentType !== "rules" && (
          <ContentTags items={tags} onChange={onTagChange} />
        )}
      </StyledPreviewWrapper>

      {contentType !== "rules" &&
        (imageUrl && (
          <Figure>
            <img src={imageUrl} alt="" />
          </Figure>
        ))}

      {contentType !== "rules" && (
        <Label label="Lisää artikkelin kuva...">
          <input
            name="image"
            type="file"
            style={{ marginTop: "0.25rem" }}
            onChange={onFileInputChange}
          />
        </Label>
      )}
      {contentType !== "rules" && (
        <LabelInput
          type="text"
          label="...tai syötä linkki videoon"
          name="videoUrl"
          value={videoUrl}
          error={errors["videoUrl"] && touchedFields.indexOf("videoUrl") > -1}
          errorMessage={errors["videoUrl"]}
          onChange={onInputChange}
        />
      )}
      {contentType !== "rules" && (
        <StyledCheckBox
          gray
          name="pinned"
          value={pinned}
          label="Kiinnitä julkaisu"
          onChange={onInputChange}
          style={{ paddingTop: "0" }}
        />
      )}

      {formError && <FormError>{formError}</FormError>}

      <footer>
        <Button theme="light" onClick={onCancel}>
          {Localize("action.cancel")}
        </Button>
        {showDeleteButton && (
          <Button theme="light" onClick={onDelete}>
            {Localize(`${contentType}.delete`)}
          </Button>
        )}
        <Button
          disabled={!isValid || !enabled}
          type="submit"
          icon="#chevron-right"
          iconRight={true}
        >
          {Localize(`${contentType}.publish`)}
        </Button>
      </footer>
    </Form>
  );
};

export default ContentForm;



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentForm.js